export default __webpack_public_path__ + "assets/images/ec1c1ccf3a1c72165e8a2c92cf1b4101-processing_icon_thin.svg";